<template>
    <div>
      
      <Header active="navId"></Header>
      
      <div class="contain " style="margin: 50px auto;">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-breadcrumb separator="/" v-if="nav">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'Article', query: {nav_id: nav.id} }">{{nav.name}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          
          <div class="content" v-if="info">
            <h1>{{info.title}}</h1>
            <div class="ftitle" v-if="info.source || info.author">来源：{{info.source}}</div>
            <div class="html" v-if="!info.redirect_url"  v-html="info.content"></div>
            <div v-else>
              <Preview :info="attachment" v-if="loading"></Preview>
            </div>
          </div>
          <div  v-else description="暂无数据">暂无数据</div>
        </el-card>
        
      </div>
  
      <Footer></Footer>
    </div>
  </template>
  
  <script>
  import Header from '@/components/header'
  import Footer from '@/components/footer'  
  import Preview from '@/components/preview'

  import { articleInfo as articleInfoApi } from '@/api/index'
  export default {
    data() {
      return {
        articleId: '',
        nav: null,
        info: null,
        loading: false,
        attachment: null
      };
    },
    components: {
      Header, Footer, Preview
    },
    created(){
      this.articleId = this.$route.params.id
      this.getInfo()
    },
    methods: {
      getInfo(){
        articleInfoApi({id: this.articleId}).then(res=> {
          this.loading = true
          this.nav = res.info.nav
          this.info = res.info
          if(res.info && res.info.redirect_url) {
            let extension = res.info.redirect_url.split('.').pop()
            this.attachment = {
              extension,
              file: res.info.redirect_urls
            }
          }
          
        })
      },
    },
  };
  </script>
  
  <style scoped>
  .content{
    padding: 20px;
  }
  .content h1{
    text-align: center;
    line-height: 60px;
  }
  .ftitle{
    text-align: center;
    margin: 10px auto;
  }
  .content .html{
    margin: 20px auto;
    line-height: 30px;
    font-size: 16px;
  }

  </style>
  